import { API_ROOT } from "environment";

angular.module("app.resources").factory("User", ($q, $resource) => {
  var User = $resource(
    `${API_ROOT}/accounts/:account_id/users/:id`,
    { account_id: "@account_id", id: "@id" },
    {
      me: {
        method: "GET",
        url: `${API_ROOT}/user`,
      },
      get: {
        method: "GET",
        transformResponse: (data) => {
          const user = angular.fromJson(data);
          if (!user.internal_metadata) {
            user.internal_metadata = {};
          }
          return user;
        },
      },
      update: {
        method: "PUT",
      },
      search: {
        method: "GET",
        url: `${API_ROOT}/users`,
        isArray: true,
      },
      contact: {
        method: "GET",
        url: `${API_ROOT}/accounts/:account_id/users/:id/contact`,
        // Since 404s will happen for any contact that was deleted from HubSpot,
        // do our own error handling.
        "Interceptor-Ignore-Errors": true,
      },
      passwordReset: {
        method: "POST",
        url: `${API_ROOT}/accounts/:account_id/users/:id/reset_password`,
      },
    }
  );

  User.prototype.isAdmin = function () {
    return (
      _.contains(this.roles, "boxcast-admin") ||
      _.contains(this.roles, "boxcast-system-admin") ||
      _.contains(this.roles, "reseller-admin")
    );
  };

  User.prototype.isBoxcastAdmin = function () {
    return (
      _.contains(this.roles, "boxcast-admin") ||
      _.contains(this.roles, "boxcast-system-admin")
    );
  };

  User.prototype.isSystemAdmin = function () {
    return _.contains(this.roles, "boxcast-system-admin");
  };

  User.prototype.isCustomAppDev = function () {
    // XXX: Special dispensation for Gary to be a custom app developer ;-)
    return this.isSystemAdmin() || this.email == "gary.buchanan@boxcast.com" || this.email == "brent.sisley@boxcast.com";
  };

  return User;
});



// WEBPACK FOOTER //
// ./resources/user.js